<template>
     <div class="">
         <ImageDrop :ref="uniqueID" @newFile="newFile" :src="downloadURL" style="width:100%;"></ImageDrop>
         <FileSelect v-on:fileSelected="fileSelected"></FileSelect>
         <v-btn @click="removeImage" v-if="downloadURL" >Remove</v-btn>
         <v-btn  @click.stop="editImage" v-if="downloadURL" >Edit</v-btn>
         <v-dialog v-model="dialog" lazy >
           <v-card>
             <v-container fluid>

              <MiniPaint
                  :ref="minipaintID"
                  :img="currentImg"
                  :imgChanged="imgChanged"
                  @cancel="cancelMiniPaint"
                  width='250px'>
              </MiniPaint>
          </v-container>
          </v-card>

         </v-dialog>
     </div>

</template>

<script>
import {Drag, Drop} from 'vue-drag-drop'
import Vue from 'vue'
// import config from '../../config.js'
// import utils from '../../utils.ts'
import {mapState} from 'vuex'
import FileSelect from './FileSelect'
import ImageDrop from './ImageDrop'
import MiniPaint from './MiniPaint'

// const uuidv1 = require('uuid/v1')

Vue.component('drag', Drag)
Vue.component('drop', Drop)

export default {
  name: 'Thumbnail',
  components: {
    FileSelect, ImageDrop, MiniPaint
  },
  props: ['origImg'],
  data () {
    return {
      progressPercentage: 0,
      uploading: false,
      currentImg: null,
      imagesToRemove: [],
      dialog: false,
      fileChanged: false,
      forceUpdate: 0,
      minipaintID: 'minipaint'
    }
  },
  computed: {
    ...mapState({
      uid: state => state.admin.uid
    }),
    downloadURL () {
      if (this.forceUpdate === -11) {
        return 'ERROR'
      }
      if (this.currentImg && this.currentImg.imgBlob) {
        return this.currentImg.imgBlob
      } else if (this.currentImg && this.currentImg.dataURL) {
        return this.currentImg.dataURL
      } else if (this.currentImg && this.currentImg.downloadURL) {
        return this.currentImg.downloadURL
      } else {
        return null
      }
    },
    uniqueID () {
      return 'imageDrop' + this._uid
    }
  },
  watch: {
    origImg (val) {
      if (!val) return
      // const pic = val
      // console.log('Current Pic is: ' + pic.downloadURL)
      this.currentImg = {...val} // Make the reactive-ness fire!
      // this.currentImg['downloadURL'] = pic.downloadURL
      // this.currentImg['thumbDownloadURL'] = pic.thumbDownloadURL
      // this.currentImg['imgPath'] = pic.imgPath
      // this.currentImg['fileName'] = pic.fileName
      // this.currentImg['thumbFileName'] = pic.thumbFileName
    }
  },
  mounted () {
  },
  methods: {
    getCurrentPic: function () { // externally used
      return this.currentImg
    },
    wasFileChanged: function () { // externally used
      return this.fileChanged
    },
    fileSelected: function (theFiles) {
      // A file was chosen, convert to a dataURL and store it.
      this.$refs[this.uniqueID].handleFiles(theFiles)
    },
    newFile: function (fileInfo) {
      // fileInfo now has:
      //    {'imgBlob': this.imgBlob, 'fileName': this.file.name}
      console.log('Thumbnail processing new file ' + fileInfo.fileName)
      // {'dataURL': this.dataURL, 'fileName': this.file.name}
      // if (this.currentImg == null) {
      //   this.currentImg = {}
      // }
      this.currentImg = fileInfo
      // {
      //   dataURL: fileInfo.dataURL,
      //   fileName: fileInfo.fileName
      // }
      this.fileChanged = true
    },
    cancelMiniPaint: function () {
      this.dialog = false
      this.forceUpdate += 1
      this.fileChanged = false
    },
    imgChanged: function (newDataURL, isBlob) {
      // This is called after editing the img
      // so we close the dialog and update the img.
      console.log('imgChanged: ' + isBlob)
      if (isBlob) {
        this.currentImg.imgBlob = newDataURL
      } else {
        throw new Error('imgChange got a non-blob... error')
        // this.currentImg = {
        //   dataURL: newDataURL,
        //   fileName: this.currentImg.fileName
        // }
        // console.log('New Img Data: ' + newDataURL.substring(0, 100))
      }

      this.dialog = false
      this.forceUpdate += 1
      this.fileChanged = true
    },
    editImage: function () {
      this.dialog = true

      // Now we load it?
      const func = () => {
        if (this.$refs[this.minipaintID]) {
          this.$refs[this.minipaintID].load()
        } else {
          window.setTimeout(func, 100)
        }
      }

      func()
    },
    removeImage: function () {
      // Remove from storage if present (and the database)
      if (!this.currentImg) {
        this.errMessage = 'No picture is there to remove'
      }

      this.currentImg = null
      this.fileChanged = true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.thumbnail {
    background-color: red;
    margin:5px;
}
.dropTarget {
    border-style: dotted;
    min-height:50px;
}

.thumbnailimg {
    width:100%;
}

</style>
